import { render, staticRenderFns } from "./ScriptTaskEditor.vue?vue&type=template&id=35f08ac2"
import script from "./ScriptTaskEditor.vue?vue&type=script&lang=js"
export * from "./ScriptTaskEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports